import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";

import {loadingMessage} from "@Xpresso/loaders/loading-message";

import {Layout} from "../../../../layout/layout";

export const loadItem = ({itemId, next: rootNext}) => cs(
    consumeContext("apis"),
    ["item", ({apis}, next) => Load({
        fetch: () => apis.next.item.getItem(itemId),
        next,
    })],
    ["error", ({item}, next) => next(
        !item ? (
            loadingMessage({message: "Loading Order...", progress: 20})
        ) : (
            ( ["failure"].includes(item?.value?.result) && ["inactive"].includes(item?.value?.errors?.template) ) ? (
                <div className="center">
                    {item?.value?.errors?.msg}
                </div>
            ) :
            (!["pending", "pending_approval", "pending approval"].includes(item.status) ? (
                    <div className="center">
                        This order was already completed.<br/>
                        Please go to order history.
                    </div>
                ) : !item?.sku?.front ? (
                    <div className="center">
                        There was a problem locating your order.<br/>
                        Please go back and try again.
                    </div>
                ) : (
                    null
                )
            )
        )
    )],
    ({item, error}) => error ? (
        <Layout className="customize-layout-95r" active={"product-options"}>
            <div className="product-options-step-6rz">
                {error}
            </div>
        </Layout>
    ) : (
        rootNext(item)
    ),
);